import {
  HHBox,
  HHDateRangePicker,
  HHStack,
  HHTextField,
  HHTypography,
} from '@hinge-health/react-component-library';
import { DATE_RANGE_PICKER_LABELS } from '../constants/partner-data-gateway.constant';

/**
 * The module's own date range picker.
 *
 * This is a copy of Hinge Connect's `date-range-picker` rather than an
 * import of it. The Partner Data Gateway boundary rule
 * (`import/no-restricted-paths`) forbids importing from outside the module,
 * so that the module stays self-contained and can be lifted into a
 * standalone app without dragging a sibling ROI module along with it.
 */
export type DateRangePickerValue = Date | null;

interface DateRangePickerProps {
  label?: string;
  helperText?: string;
  dateRange: [DateRangePickerValue, DateRangePickerValue];
  setDateRange: React.Dispatch<
    React.SetStateAction<[DateRangePickerValue, DateRangePickerValue]>
  >;
  startDateTestId?: string;
  endDateTestId?: string;
}

export const DateRangePicker = ({
  label,
  helperText,
  dateRange,
  setDateRange,
  startDateTestId,
  endDateTestId,
}: DateRangePickerProps): JSX.Element => (
  <HHBox marginY="1rem">
    {label && <HHTypography hhVariant="input-label">{label}</HHTypography>}
    <HHDateRangePicker
      localeText={{
        start: DATE_RANGE_PICKER_LABELS.startDate,
        end: DATE_RANGE_PICKER_LABELS.endDate,
      }}
      onChange={(data): void => {
        setDateRange(data);
      }}
      value={dateRange}
      renderInput={(startProps, endProps): JSX.Element => (
        <HHStack direction="row" spacing={6} alignItems="center">
          <HHTextField
            hhVariant="variant-bypass"
            {...startProps}
            inputProps={{
              ...startProps.inputProps,
              'data-testid': startDateTestId,
            }}
          />
          <HHTypography hhVariant="body">
            {DATE_RANGE_PICKER_LABELS.to}
          </HHTypography>
          <HHTextField
            hhVariant="variant-bypass"
            {...endProps}
            inputProps={{
              ...endProps.inputProps,
              'data-testid': endDateTestId,
            }}
          />
        </HHStack>
      )}
    />
    {helperText && (
      <HHTypography hhVariant="input-label">{helperText}</HHTypography>
    )}
  </HHBox>
);
